import { createSlotRecipe } from './runtime';

const clipboardConfig = {"name":"clipboard","slots":["root","control","trigger","indicator","input","label"]}

export const clipboard = /* @__PURE__ */ createSlotRecipe(clipboardConfig)